import RadioGroup, { RadioGroupProps } from "@mui/material/RadioGroup";

export type { RadioGroupProps };
export default RadioGroup;
